// extracted by mini-css-extract-plugin
export default {"achievements":"Achievements_achievements__Agswp","container":"Achievements_container__WT-QN","achievementContainer":"Achievements_achievementContainer__rrsmb"};